import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import ActionCenterMessageDetail from './ActionCenterMessageDetail';
import { ConversationListType } from '../../Enums/ConversationListType.enum';

interface Props {
	isOpen: true;
	onClose: () => void;
	conversationId: string;
	type: ConversationListType;
}

const ActionCenterMessageDetailModal: React.FC<Props> = ({
	isOpen,
	onClose,
	conversationId,
	type,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.FULLSCREEN}>
			<Modal.Content>
				<div style={{ margin: '-34px -24px' }}>
					<ActionCenterMessageDetail
						conversationId={conversationId}
						onBack={onClose}
						type={type}
					/>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default ActionCenterMessageDetailModal;
